<div class="contact-support-conatiner">
  <h2>Have any questions?</h2>
  <div class="subtitle">
    Our team is here to help you get the most out of Board Demo portal. Speak with an expert—and we’ll ensure you get the answers you need.
  </div>
  <brd-button href="/support" iconName="mail-16" text="contact support"> </brd-button>
  <img class="bubble-left" src="assets/images/bubble-left.png" />
  <img class="bubble-right" src="assets/images/bubble-right.png" />
</div>
